export const DirectionConstants = {
    GET_DIRECTION: 'GET_DIRECTION',
    SET_DIRECTION: 'SET_DIRECTION'
};